import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import { CircleBreakIcon } from "@images/svgIcons/circleBreakIcon"
import { CircleTimeIcon } from "@images/svgIcons/circleTimeIcon"
import { InfinityIcon } from "@images/svgIcons/infinityIcon"
import { PlayIcon } from "@images/svgIcons/playIcon"
import { SetsIcon } from "@images/svgIcons/setsIcon"

type ChronoRecapBlocProps = {
  circleTimeIcon?: boolean
  circleBreakIcon?: boolean
  infinityIcon?: boolean
  playIcon?: boolean
  setsIcon?: boolean
  value?: string | number
  className?: string
} & React.ComponentProps<"div">

export function ChronoRecapBloc({
  circleTimeIcon,
  circleBreakIcon,
  infinityIcon,
  playIcon,
  setsIcon,
  value,
  className,
  ...props
}: ChronoRecapBlocProps) {
  return (
    <div
      className={cn("flex flex-1 items-center justify-center gap-2 bg-surface-background", className)}
      style={{ padding: 10, borderRadius: 10 }}
      {...props}
    >
      {circleTimeIcon && (
        <CircleTimeIcon color="currentColor" className="shrink-0 text-textDefault-heading" width={16} height={16} />
      )}
      {circleBreakIcon && (
        <CircleBreakIcon color="currentColor" className="shrink-0 text-textDefault-heading" width={16} height={16} />
      )}
      {setsIcon && (
        <SetsIcon color="currentColor" className="shrink-0 text-textDefault-heading" width={16} height={16} />
      )}
      {playIcon && (
        <PlayIcon color="currentColor" className="shrink-0 text-textDefault-heading" width={16} height={16} />
      )}
      {infinityIcon && (
        <InfinityIcon color="currentColor" className="shrink-0 text-textDefault-heading" width={16} height={16} />
      )}

      {value !== "" && <Text fontStyle="BM">{value}</Text>}
    </div>
  )
}
